import axios from 'axios';

const apiClient = axios.create({
    // baseURL: import.meta.env.VITE_APP_URL || 'http://osis.sman2amlapura.sch.id/',
    timeout: 5000,
});

apiClient.interceptors.request.use((config) => ({
    ...config,
    headers: { ...config.headers, 'X-API-KEY': import.meta.env.VITE_API_KEY || 'default-api-key' }
}), Promise.reject);

apiClient.interceptors.response.use((response) => response, (error) => {
    if (error.response?.status === 401) window.location.href = 'https://admin.sman2amlapura.sch.id/login';
        return Promise.reject(error);
});

export default apiClient;

